<template>
    <div class="content">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="合同管理" name="1">
                    <div>
                        <span style="margin-right: 20px">合同信息</span>
                        <el-button v-for="(item, key) in buttonList" :key="key" type="primary" :disabled="item.value == '不可用'" @click="buttonDispose(item.name)">{{ item.name }}</el-button>
                        <span style="margin-left: 50px">打印：</span>
                        <el-button type="primary" @click="SPCOrdersShoppingList_HTML" :disabled="result.Orders_Status == 3 || result.Orders_AuditStatus != 1">打印</el-button>
                        <el-button v-if="isReturnGoods != 1" type="primary" @click="SPCOrdersProductExport">导出商品清单</el-button>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="基本信息" name="2">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="合同号">
                            <div class="rows">
                                {{ result.Orders_SN }} (
                                <span :class="judgeColor(ordersStatus)">{{ ordersStatus }}</span>
                                )
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="下单时间">
                            <div class="rows">{{ result.Orders_Addtime | formatDates }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="报价单编号">
                            <span class="links" @click="goSPCdetail">{{ result.Orders_SPCApplySN }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同类型">{{ result.Orders_TradeType == 1 ? '服务和物联网合同' : '销售合同' }}</el-descriptions-item>
                        <el-descriptions-item label="审核状态">
                            <div :class="judgeColor(allStatus.auditStatus)">{{ allStatus.auditStatus }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="BPM审核状态">
                            <div>
                                <span style="margin-right: 20px" :class="judgeColor(allStatus.ordersBPMAuditStatus)">{{ allStatus.ordersBPMAuditStatus }}</span>
                                <el-button type="primary" v-if="result.Orders_BPMAuditStatus > 0 && result.Orders_BPMBizObjectID != ''" @click="searchBpm(result.Orders_BPMBizObjectID)">查询审批情况</el-button>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同纸回收状态">
                            <div :class="judgeColor(allStatus.ordersContractReceive)">{{ allStatus.ordersContractReceive }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="电子签章状态">
                            <div :class="judgeColor(allStatus.ordersESignStatus)">{{ allStatus.ordersESignStatus }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="办事处">{{ result.Orders_OfficeCode }}</el-descriptions-item>
                        <el-descriptions-item label="业务员">{{ officemanInfo.OwnerName }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称">{{ result.Orders_ProjectName }}</el-descriptions-item>
                        <el-descriptions-item label="工程地址">{{ result.projectDetails }}</el-descriptions-item>
                        <el-descriptions-item label="质保期">{{ result.Orders_Warranty }}</el-descriptions-item>
                        <el-descriptions-item label="行业分类">{{ ProjectType_name }}</el-descriptions-item>
                        <!-- <el-descriptions-item span="2" label="工基建项目说明">{{ result.Orders_ProjectNote
                        }}</el-descriptions-item> -->
                        <el-descriptions-item label="配送方式">{{ result.Orders_Delivery_Name }}</el-descriptions-item>
                        <el-descriptions-item label="支付方式">{{ result.Orders_Payway_Name }}</el-descriptions-item>
                        <el-descriptions-item label="发货类型">{{ result.Orders_IsAllFreight == 0 ? '分批发货' : '整单发货' }}</el-descriptions-item>
                        <el-descriptions-item label="发货方式">
                            {{ result.Orders_FreightType == 0 ? '即时发货' : '审核订单后发货' }}
                            <span class="red">{{ result.Orders_IsPayAuditDelivery == 1 ? '付款审核后直接发货' : '' }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="是否缺货合同">{{ result.Orders_IsShortStock == 0 ? '否' : '是' }}</el-descriptions-item>
                        <el-descriptions-item label="交货时间">{{ result.Orders_DeliveryTime }}</el-descriptions-item>
                        <el-descriptions-item label="短信通知">
                            <span class="content_value" v-if="result.Orders_MsgNotify == 0">客户 业务员</span>
                            <span class="content_value" v-if="result.Orders_MsgNotify == 1">客户</span>
                            <span class="content_value" v-if="result.Orders_MsgNotify == 2">业务员</span>
                            <span class="content_value" v-if="result.Orders_MsgNotify == -1">均不通知</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="免盖章">
                            <template v-if="NoCustomerSign.IsSHowCheckbox == 'true'">
                                <el-checkbox v-model="NoCustomerSign.Checkbox" @change="handleCheckboxChange" :checked="NoCustomerSign.Checkbox === 'true'"></el-checkbox>
                                <span class="red">{{ NoCustomerSign.CheckboxName }}</span>
                            </template>
                            <template v-else>
                                <span class="red">{{ NoCustomerSign.CheckboxName }}</span>
                            </template>
                        </el-descriptions-item>
                        <el-descriptions-item label="纸质合同号">{{ result.Orders_PaperContractSN }}</el-descriptions-item>
                        <el-descriptions-item label="期望交货时间">{{ result.Orders_PlanDeliveryDate | formatDate }}</el-descriptions-item>
                        <el-descriptions-item label="项目类型">{{ ordersProjectTypeStatus }}</el-descriptions-item>
                        <el-descriptions-item label="一次全部发货">
                            <span class="red-title">{{ result.Orders_IsAllReach == 0 ? '否' : '是' }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="合同其他约定">{{ result.Orders_OtherAgreement }}</el-descriptions-item>
                        <el-descriptions-item span="2" label="配电柜厂家">{{ cabinetSupplier }}</el-descriptions-item>
                        <el-descriptions-item span="2" label="合同备注">
                            <div slot="label">
                                <div class="red-title">合同备注</div>
                            </div>
                            {{ result.Orders_Note }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="付款方式" name="3" v-if="payMentDetails && payMentDetails.Detail">
                    <el-table :data="payMentDetails.Detail" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }" :span-method="paymentSpanMethod">
                        <el-table-column label="付款方式" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.$index === 0">{{ payMentDetails.PayTypeName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Remark" label="描述" align="center"></el-table-column>
                        <el-table-column prop="Proportion" label="比例（%）" align="center"></el-table-column>
                        <el-table-column prop="Day" label="至到期日的天数" align="center"></el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="客户信息" name="4">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="客户编码	">
                            <div class="rows">{{ result.Orders_CustomerCode }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户名称">
                            <div class="rows">{{ result.Orders_CustomerName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="客户姓名" v-if="result.Orders_CustomerSubID > 0">
                            <div class="rows">{{ customerSubInfo.Customer_Sub_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="年检到期日期">
                            {{ customerInfo.Customer_CertExpireDate | formatDate }}
                        </el-descriptions-item>
                        <el-descriptions-item label="会员账号">
                            {{ memberInfo.Member_NickName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="姓名">
                            {{ memberInfo.MemberProfileInfo.Member_Name }}
                        </el-descriptions-item>
                        <el-descriptions-item label="固定电话">
                            {{ memberInfo.MemberProfileInfo.Member_Phone_Number }}
                        </el-descriptions-item>
                        <el-descriptions-item label="手机">
                            {{ memberInfo.MemberProfileInfo.Member_Mobile }}
                        </el-descriptions-item>
                        <el-descriptions-item label="Email">
                            {{ memberInfo.Member_Email }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="收货人信息" name="5">
                    <template slot="title">
                        收货人信息[{{ result.Orders_Address_Type=="Y"?"客户地址":"办事处地址" }}]
                        
                    </template>
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="姓名	">
                            <div class="rows">{{ result.Orders_Address_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="固定电话">
                            <div class="rows">{{ result.Orders_Address_Phone_Number }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="手机">
                            {{ result.Orders_Address_Mobile }}
                        </el-descriptions-item>
                        <el-descriptions-item label="地址">
                            {{ result.addressDetails +' '+ result.Orders_Address_StreetAddress}}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="客户联系人" name="6">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="联系人	">
                            <div class="rows">{{ result.Orders_Contract_Name }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系电话">
                            <div class="rows">{{ result.Orders_Contract_Mobile }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人Email">
                            {{ result.Orders_Contract_Email }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="关联商机信息" name="6-pipeline" v-if="ordersSMDSPipelineInfo">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="商机编码">
                            <div class="rows">{{ ordersSMDSPipelineInfo.opportunityName }}({{ ordersSMDSPipelineInfo.ID }})</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="项目名称">
                            <div class="rows">{{ ordersSMDSPipelineInfo.projectName }}({{ ordersSMDSPipelineInfo.entityType }})</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="项目阶段">
                            {{ ordersSMDSPipelineInfo.stageName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="客户信息">
                            （{{ ordersSMDSPipelineInfo.erpid }}）{{  ordersSMDSPipelineInfo.accountName }}
                            
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            {{ ordersSMDSPipelineInfo.contact }}
                        </el-descriptions-item>
                        <el-descriptions-item label="所有人">
                            {{ ordersSMDSPipelineInfo.userName }}
                        </el-descriptions-item>
                        <el-descriptions-item label="预计项目金额">
                            {{ ordersSMDSPipelineInfo.money }}
                        </el-descriptions-item>
                        <el-descriptions-item label="项目类型">
                            {{ ordersSMDSPipelineInfo.industry1 }}
                        </el-descriptions-item>
                        <el-descriptions-item label="需货时间">
                            {{ ordersSMDSPipelineInfo.demandDate }}
                        </el-descriptions-item>
                        <el-descriptions-item label="创建日期">
                            {{ ordersSMDSPipelineInfo.createdAt }}
                        </el-descriptions-item>
                        <el-descriptions-item label="项目地址">
                             {{ ordersSMDSPipelineInfo.province }} {{ ordersSMDSPipelineInfo.city }} {{ ordersSMDSPipelineInfo.area }} {{ ordersSMDSPipelineInfo.address }}
                           
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>


                <el-collapse-item title="电子签章" name="7" v-if="result.Orders_ESignStatus > 0">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="签章状态">
                            <div class="rows" :class="judgeColor(allStatus.ordersESignStatus)">{{ allStatus.ordersESignStatus }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            <div class="rows">{{ result.Orders_ESignName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人手机">
                            {{ result.Orders_EsignMobile }}
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="发票信息" name="8" v-if="0">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="发票类型	">
                            <div class="rows">{{ Invoicedetails.Invoice_Type }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="单位名称">
                            <div class="rows">{{ Invoicedetails.Invoice_VAT_FirmName }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="纳税人识别号">
                            <div>{{ Invoicedetails.Invoice_VAT_Code }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="注册地址">
                            <div>{{ Invoicedetails.Invoice_VAT_RegAddr }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="注册电话">
                            {{ Invoicedetails.Invoice_VAT_RegTel }}
                        </el-descriptions-item>

                        <el-descriptions-item label="开户银行">
                            <div>{{ Invoicedetails.Invoice_VAT_Bank }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="银行账户">
                            {{ Invoicedetails.Invoice_VAT_BankAcount }}
                        </el-descriptions-item>

                        <el-descriptions-item label="发票内容">
                            <div>{{ Invoicedetails.Invoice_VAT_Content }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="收票人">{{}}</el-descriptions-item>
                        <el-descriptions-item label="发票邮寄地址">{{}}</el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>

                <el-collapse-item title="关联订单" name="9">
                    <div>
                        <el-button v-for="(item, key) in batchButtonList" :key="key" :disabled="item == '不可用' || (SPCOrdersRelateList && SPCOrdersRelateList.length == 0)" type="primary" @click="batchButtonClk(key)">{{ key }}</el-button>
                    </div>
                    <div style="margin-top: 10px">
                        <el-table :data="SPCOrdersRelateList" border style="width: 100%" ref="ordersRelateTble" :header-cell-style="{ backgroundColor: '#EBEEF5' }" @selection-change="handleSelectionChange">
                            <el-table-column align="center" type="selection" width="55" fixed></el-table-column>
                            <el-table-column label="序号" align="center" width="80">
                                <template v-slot="scope">{{ scope.$index + 1 }}</template>
                            </el-table-column>
                            <el-table-column prop="Orders_SN" label="订单号" align="center">
                                <template v-slot="scope">
                                    <span class="links" @click="goOrderdetail(scope.row.Orders_ID)">{{ scope.row.Orders_SN }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Orders_ERPSN" label="ERP订单号" align="center"></el-table-column>
                            <el-table-column prop="Orders_AuthorizeCode" label="订单类型" align="center"></el-table-column>
                            <el-table-column prop="Orders_Return_AllPrice" label="返货金额" align="center">
                                <template v-slot="scope">￥ {{ getFloat(scope.row.Orders_Return_AllPrice || 0, 2) }}</template>
                            </el-table-column>
                            <el-table-column prop="Orders_Total_AllPrice" label="订单总额" align="center">
                                <template v-slot="scope">￥ {{ getFloat(scope.row.Orders_Total_AllPrice || 0, 2) }}</template>
                            </el-table-column>
                            <el-table-column prop="StateName" label="订单状态" align="center">
                                <template v-slot="scope">
                                    <span :class="judgeColor(scope.row.StateName)">{{ scope.row.StateName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="BPMStateName" label="BPM审核状态" align="center">
                                <template v-slot="scope">
                                    <span :class="judgeColor(scope.row.BPMStateName)">{{ scope.row.BPMStateName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Orders_Addtime" label="下单时间" align="center">
                                <template v-slot="scope">{{ scope.row.Orders_Addtime | formatDates }}</template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="业绩分配比例" name="10">
                    <el-table :data="distributeList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                        <el-table-column label="有效日期" align="center">
                            <template v-slot="scope">{{ scope.row.ValidStartDate }} - {{ scope.row.ValidEndDate }}</template>
                        </el-table-column>
                        <el-table-column prop="No" label="创建时间" align="center">
                            <template v-slot="scope">{{ scope.row.AddTime | formatDates }}</template>
                        </el-table-column>
                        <el-table-column label="办事处编码" align="center" :cell-style="cellStyle">
                            <template v-slot="scope">
                                <div class="office-box" v-for="(item, index) in scope.row.OfficeMember" :key="index">
                                    <div>{{ item.OfficeCode }}</div>
                                    <!-- <el-table :data="scope.row.OfficeMember" :show-header="false" class="no-border-table">
                                        <el-table-column prop="OfficeCode" label="" align="center"></el-table-column>
                                    </el-table> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="业务员编码" align="center">
                            <template v-slot="scope">
                                <div class="office-box" v-for="(item, index) in scope.row.OfficeMember" :key="index">
                                    <div>{{ item.OfficeMemberCode }}</div>
                                    <!-- <el-table :data="scope.row.OfficeMember">
                                        <el-table-column prop="OfficeMemberCode" label="" align="center"></el-table-column>
                                    </el-table> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" align="center">
                            <template v-slot="scope">
                                <div class="office-box" v-for="(item, index) in scope.row.OfficeMember" :key="index">
                                    <div>{{ item.OfficeMemberName }}</div>
                                    <!-- <el-table :data="scope.row.OfficeMember" :show-header="false" class="no-border-table">
                                        <el-table-column prop="OfficeMemberName" label="" align="center"></el-table-column>
                                    </el-table> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="分配比例（%）" align="center">
                            <template v-slot="scope">
                                <div class="office-box" v-for="(item, index) in scope.row.OfficeMember" :key="index">
                                    <div>{{ item.Rate }}</div>
                                    <!-- <el-table :data="scope.row.OfficeMember" :show-header="false" class="no-border-table">
                                        <el-table-column prop="Rate" label="" align="center"></el-table-column>
                                    </el-table> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否主业务员" align="center">
                            <template v-slot="scope">
                                <div class="office-box" v-for="(item, index) in scope.row.OfficeMember" :key="index">
                                    <div>{{ item.IsMainMember || '&nbsp;' }}</div>

                                    <!-- <el-table :data="scope.row.OfficeMember" :show-header="false" class="no-border-table">
                                        <el-table-column prop="IsMainMember" label="" align="center"></el-table-column>
                                    </el-table> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="AuditStatus" label="BPM审核状态" align="center" v-if="this.distributeshowstate == 1">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.AuditStatus)">{{ scope.row.AuditStatus }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="合同付款记录" name="11">
                    <el-table :data="payMentsHistoryList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="DiscountCate_ABType" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Payment_DocNo" label="付款单号" align="center"></el-table-column>
                        <el-table-column prop="Orders_Payment_Amount" label="付款金额" align="center">
                            <template v-slot="scope">￥ {{ getFloat(scope.row.Orders_Payment_Amount, 2) }}</template>
                        </el-table-column>
                        <el-table-column prop="PaymentStatus" label="付款状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.PaymentStatus)">{{ scope.row.PaymentStatus }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="AuditStatus" label="确认状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.AuditStatus)">{{ scope.row.AuditStatus }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Payment_Note" label="备注" align="center" show-overflow-tooltip width="500"></el-table-column>
                        <el-table-column prop="Orders_Payment_Addtime" label="付款时间" align="center">
                            <template v-slot="scope">
                                <span>{{ scope.row.Orders_Payment_Addtime | formatDates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="操作" align="center">
                            <template v-slot="scope">
                                <div class="operation-bar">
                                    <span @click="payMentsHistoryView(scope.row)" class="operation-bar-block">查看</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="合同付款分配" name="12">
                    <el-table :data="PayDistributeList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                        <el-table-column prop="DiscountCateName" label="订单类型" align="center"></el-table-column>
                        <el-table-column prop="Receipt_BankName" label="汇入银行" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                        <el-table-column prop="Receipt_Code" label="汇款单位" align="center"></el-table-column>
                        <el-table-column prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                        <el-table-column prop="Receipt_TotalAmount" label="汇款金额" align="center">
                            <template v-slot="scope">￥ {{ getFloat(scope.row.Receipt_TotalAmount, 2) }}</template>
                        </el-table-column>
                        <el-table-column prop="Receipt_Amount " label="分配金额" align="center">
                            <template v-slot="scope">￥ {{ getFloat(scope.row.Receipt_Amount, 2) }}</template>
                        </el-table-column>
                        <el-table-column prop="Receipt_AuditStatus" label="审核状态" align="center"></el-table-column>
                        <el-table-column prop="Receipt_Addtime" label="分配时间" align="center"></el-table-column>
                        <el-table-column prop="File" label="凭证信息" align="center">
                            <template v-slot="scope">
                                <div class="operation-bar" v-if="scope.row.File">
                                    <span @click="payDistributeView(scope.row.File)" class="operation-bar-block">查看</span>
                                </div>
                                <div v-else>暂无附件</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="临时发货申请" name="13">
                    <el-table :data="DeliveryApplyList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center"></el-table-column>
                        <el-table-column prop="Apply_SN" label="申请单号" align="center"></el-table-column>
                        <el-table-column prop="Attachment_Addtime" label="发货金额" align="center">
                            <template v-slot="scope">￥ {{ getFloat(scope.row.Apply_TotalPrice) }}</template>
                        </el-table-column>
                        <el-table-column prop="Apply_ValidStatus" label="生效状态" align="center"></el-table-column>
                        <el-table-column prop="Apply_Status" label="状态" align="center">
                            <template v-slot="scope">
                                <span :class="judgeColor(scope.row.Apply_Status)">{{ scope.row.Apply_Status }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Apply_AuditNote" label="备注" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Apply_Addtime" label="申请日期" align="center"></el-table-column>
                        <el-table-column prop="Attachment_AuditNote" label="操作" align="center">
                            <template v-slot="scope">
                                <div class="operation-bar">
                                    <span class="operation-bar-block" @click="deliveryApplyView(scope.row)">查看</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="折扣分组" name="16">
                    <el-table :data="applyDiscountData" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="Name" label="折扣分组" align="center"></el-table-column>
                        <el-table-column prop="OrderAmount" label="面价金额" align="center">
                            <template v-slot="scope">￥ {{ getFloat(scope.row.OrderAmount, 2) }}</template>
                        </el-table-column>
                        <el-table-column prop="ProductAmount" label="商品金额" align="center">
                            <template v-slot="scope">￥{{ getFloat(scope.row.ProductAmount, 2) }}</template>
                        </el-table-column>
                        <el-table-column prop="Discount" label="折扣率" align="center"></el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="商品清单" name="17">
                    <div class="cart-list-container">
                        <div class="cart-list" v-for="(item, index) in GoodsList" :key="index">
                            <div class="flex">
                                <div class="cart-top-title-big mr10">
                                    <span>{{ item.DiscountCateName }}</span>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                                        <el-table-column prop="Goods_Product_MainBoxNumber" label="箱号" align="center" width="80"></el-table-column>
                                        <el-table-column prop="Goods_Product_Name" label="商品" align="center" show-overflow-tooltip>
                                            <template v-slot="scope">
                                                <div class="flex">
                                                    <img :src="getProductImgUrl(scope.row)" alt="" style="width: 50px; height: 50px; margin-right: 20px" class="" />
                                                    <div class="cart-title">{{ scope.row.Goods_Product_Name }}</div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="Goods_Product_Spec" label="规格" align="center" width="200" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="Goods_Product_Maker" label="生产企业" align="center" width="200" show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="150">
                                            <template v-slot="scope">￥{{ Number(scope.row.Goods_Product_Price.toFixed(2)) }}</template>
                                        </el-table-column>
                                        <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                                        <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="150">
                                            <template v-slot="scope">￥{{ Number(scope.row.Goods_TotalPrice.toFixed(2)) }}</template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="total" v-if="item.Orders_Return_AllPrice > 0">
                                商品金额合计:
                                <span>￥{{ Number(item.Porduct_Pirce.toFixed(2)) }}</span>
                                合同金额:
                                <span>￥{{ 0 }}</span>
                                返货金额:
                                <span>￥{{ Number(item.Orders_Return_AllPrice.toFixed(2)) }}</span>
                                折扣率:{{ Number(((item.Orders_Return_AllPrice / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                                <span>{{ Number((item.Orders_Return_AllPrice / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3}}折</span>
                            </div>
                            <div class="total" v-else>
                                商品金额合计:
                                <span>￥{{ Number(item.Porduct_Pirce.toFixed(2)) }}</span>
                                合同金额:
                                <span>￥{{ Number(item.Orders_Price.toFixed(2)) }}</span>
                                折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                                <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3}}折</span>
                            </div>
                        </div>
                        <div class="total">
                            合同总金额:
                            <span>￥{{ Number(GoodsListPirce.toFixed(2)) }}</span>
                        </div>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="审核说明" name="18">
                    <el-table :data="auditLise" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Note_Note" label="备注" align="left"></el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="合同日志" name="19">
                    <el-table :data="ordersLogsList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#EBEEF5' }">
                        <el-table-column prop="No" label="序号" align="center" width="80">
                            <template v-slot="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Log_Addtime" label="时间" align="center" width="150">
                            <template v-slot="scope">
                                <span>{{ scope.row.Orders_Log_Addtime | formatDates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Orders_Log_Operator" label="操作人" align="center" width="150"></el-table-column>
                        <el-table-column prop="Orders_Log_Remark" label="备注" align="left"></el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
        <BPMExamine :isSwitch="isSwitch" :id="result.Orders_BPMBizObjectID" @setSwitchClose="setSwitchClose" v-if="isSwitch"></BPMExamine>
        <PrintHtml :isSwitch="printSwitch" :html="printHtml" :numsituation="numsituation" @setSwitchClose="printSwitchClose" :sealTrue="sealTrue" v-if="printSwitch"></PrintHtml>
        <ResendContractDialog v-if="resendSwitch" :visible="resendSwitch" :result="result" @refresh="handleRefresh" @close="resendSwitchClose" />
        <el-dialog :visible.sync="BatchUploadShow" :close-on-click-modal="false" width="90%" top="5vh" :before-close="handleClose" v-if="BatchUploadShow" custom-class="batch-deliver-dialog">
            <div>
                <BatchUpload :orderOperate="orderOperate" @BatchUploadRes="BatchUploadRes"></BatchUpload>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchPaymentShow" :close-on-click-modal="false" width="90%" top="5vh" :before-close="handleClose" v-if="BatchPaymentShow"  custom-class="batch-deliver-dialog">
            <div>
                <BatchPayment :orderOperate="orderOperate"  @BatchPaymentRes="BatchPaymentRes"></BatchPayment>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchDeliverShow" :close-on-click-modal="false" :before-close="handleClose" v-if="BatchDeliverShow" width="95%" top="5vh" :modal-append-to-body="false" custom-class="batch-deliver-dialog">
            <div>
                <BatchDeliver :orderOperate="orderOperate" @BatchDeliverRes="BatchDeliverRes"></BatchDeliver>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchTicketShow" :close-on-click-modal="false" width="90%" top="5vh" :before-close="handleClose" v-if="BatchTicketShow" custom-class="batch-deliver-dialog">
            <div>
                <BatchTicket :orderOperate="orderOperate" @BatchTicketRes="BatchTicketRes"></BatchTicket>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="BatchInvoiceShow" :close-on-click-modal="false" width="90%" top="5vh" :before-close="handleClose" v-if="BatchInvoiceShow" custom-class="batch-deliver-dialog">
            <div>
                <BatchInvoice :orderOperate="orderOperate" @BatchInvoiceRes="BatchInvoiceRes"></BatchInvoice>
            </div>
        </el-dialog>
        <el-dialog title="合同支付" :visible.sync="contractPayShow" :close-on-click-modal="false" width="1200px" append-to-body @close="contractPayShow = false">
            <contractPay
                v-if="contractPayShow"
                :OrdersID="id"
                @ContractPayRes="
                    contractPayShow = false;
                    GetSPCOrdersByID(id);
                " />
        </el-dialog>
        <el-dialog title="修改合同号" :visible.sync="modifyContractNoShow" width="500px" append-to-body>
            <el-form :model="form" ref="modifyContractNoForm" label-width="140px">
                <el-form-item :label="PaperContractSNPlace" prop="PaperContractSN">
                    <div style="display: flex; align-items: center">
                        <el-input v-model="PaperContractSN" placeholder="请输入新合同号"></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="modifyContractNoShow = false">取 消</el-button>
                <el-button type="primary" @click="submitModifyContractNo">确 定</el-button>
            </div>
        </el-dialog>
        <TemporaryDeliveryDetails :dialogVisible="isDialogVisible" :id="deliveryApply_ID" :orders="deliveryOrders_SN" @handleClose="isDialogVisible = false" />
        <ContractManagementPaymentDetail :dialogVisible="paymentShow" :id="PaymentID" @handleClose="paymentShow = false" />
        <el-dialog title="提交合同" :visible.sync="submitOrderShow":close-on-click-modal="false" v-if="submitOrderShow" width="1500px" top="5vh" style="height: 90vh">
            <SubmitPackOrder :submitOrderData="submitOrderData" @submitOrderComplete="submitOrderComplete"></SubmitPackOrder>
        </el-dialog>
    </div>
</template>


<script>
import { cloneDeep } from 'lodash';
import BPMExamine from '@/components/BPMExamine';
import PrintHtml from '@/components/PrintHtml';
import ResendContractDialog from '@/components/ResendContract';
import BatchUpload from '@/views/orderManagement/operateBatch/BatchUpload';
import BatchPayment from '@/views/orderManagement/operateBatch/BatchPayment';
import BatchDeliver from '@/views/orderManagement/operateBatch/BatchDeliver';
import BatchTicket from '@/views/orderManagement/operateBatch/BatchTicket';
import BatchInvoice from '@/views/orderManagement/operateBatch/BatchInvoice';
import contractPay from '@/components/ContractPay/index.vue';
import TemporaryDeliveryDetails from './components/TemporaryDeliveryDetails.vue';
import SubmitPackOrder from '@/views/orderManagement/submitPackOrder';
import ContractManagementPaymentDetail from './components/ContractManagementPaymentDetail.vue';

export default {
    name: 'contractmanagementDetails',
    components: {
        BPMExamine,
        PrintHtml,
        ResendContractDialog,
        BatchUpload,
        BatchPayment,
        BatchDeliver,
        BatchTicket,
        BatchInvoice,
        contractPay,
        TemporaryDeliveryDetails,
        SubmitPackOrder,
        ContractManagementPaymentDetail
    },
    data() {
        return {
            modifyContractNoShow: false,
            form: {
                newContractNo: ''
            },
            activeNames: [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '6-pipeline',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12',
                '13',
                '16',
                '17',
                '18',
                '19' // 所有可能的 name
            ],
            id: 0,
            paymentShow: false,
            PaymentID: null,
            PaymentSN: '',
            paymentDetail: {},
            // 凭证表格数据，后续可用接口返回替换
            voucherList: [],
            NoCustomerSign: {},
            Orders_IsAllFreight: 0,
            PaperContractSNPlace: 'GST-' + new Date().getFullYear() + '-No.',
            PaperContractSN: '',
            result: {
                Orders_Account_Pay: 0,
                Orders_Address_City: '',
                Orders_Address_Country: '',
                Orders_Address_County: '',
                Orders_Address_ID: 0,
                Orders_Address_Mobile: '',
                Orders_Address_Name: '',
                Orders_Address_Phone_Areacode: '',
                Orders_Address_Phone_Countrycode: '',
                Orders_Address_Phone_Number: '',
                Orders_Address_State: '5',
                Orders_Address_StreetAddress: '',
                Orders_Address_Type: 'Y',
                Orders_Address_Zip: '',
                Orders_Addtime: '',
                Orders_Admin_Note: '',
                Orders_Admin_Sign: 0,
                Orders_Attachment: '',
                Orders_AttachmentAudit: 0,
                Orders_AttachmentAudit_Time: '',
                Orders_AuditStatus: 1,
                Orders_AuditTime: '',
                Orders_AuditorID: 0,
                Orders_AuditorSort: 0,
                Orders_AuthorizeCode: '',
                Orders_BPMAuditStatus: 2,
                Orders_BPMBizObjectID: '',
                Orders_BreakResponsibility: '',
                Orders_BuyerID: 246,
                Orders_CashOutputStatus: 0,
                Orders_CoinbuyNotifyStatus: 0,
                Orders_Contract_Email: '',
                Orders_Contract_Mobile: '',
                Orders_Contract_Name: '',
                Orders_CustomerCode: '',
                Orders_CustomerID: 247,
                Orders_CustomerMobile: '',
                Orders_CustomerName: '',
                Orders_CustomerPartA: '',
                Orders_CustomerSubID: 0,
                Orders_Delivery: 4,
                Orders_DeliveryStatus: 0,
                Orders_DeliveryStatus_Time: '',
                Orders_DeliveryTime: '',
                Orders_Delivery_Name: '',
                Orders_DiscountCate: 'F',
                Orders_DiscountRate: 0.09,
                Orders_DistrictCode: '',
                Orders_ERPDepotID: 0,
                Orders_ERPSN: '',
                Orders_ERPSyncStatus: 0,
                Orders_Fail_Addtime: '',
                Orders_Fail_Note: '',
                Orders_Fail_SysUserID: 0,
                Orders_FreightType: 1,
                Orders_From: '',
                Orders_GatheringDefault: 0,
                Orders_GroupOrdersID: 3592,
                Orders_ID: 3592,
                Orders_InvoiceCode: '',
                Orders_InvoiceOutputStatus: 0,
                Orders_InvoiceOutputStatus_Time: '',
                Orders_InvoiceStatus: 3,
                Orders_IsAllDelivery: 0,
                Orders_IsAllDeliveryApply: 0,
                Orders_IsAllFreight: 1,
                Orders_IsAllReach: 0,
                Orders_IsAreaSpan: 0,
                Orders_IsEvaluate: 0,
                Orders_IsNoCustomerSign: 0,
                Orders_IsPayAuditDelivery: 0,
                Orders_IsReturnCoin: 0,
                Orders_IsShortStock: 0,
                Orders_IsSpecialPriceAudit: 0,
                Orders_MarketCode: '',
                Orders_MsgNotify: -1,
                Orders_MsgNotifyEnable: 0,
                Orders_MsgNotifyStatus: 0,
                Orders_NextPay_Days: 0,
                Orders_Note: '',
                Orders_OfficeCode: '',
                Orders_OfficeID: 149,
                Orders_OfficeManCode: '',
                Orders_OfficeManID: 54,
                Orders_OtherAgreement: '',
                Orders_PayType: 1,
                Orders_PayType_Name: '',
                Orders_PayType_Sign: '',
                Orders_PaymentNotifyNum: 0,
                Orders_PaymentNotifyTime: '',
                Orders_PaymentReceiptType: '0',
                Orders_PaymentStatus: 0,
                Orders_PaymentStatus_Time: '',
                Orders_Payway: 6,
                Orders_Payway_Name: '',
                Orders_PrePay_Percent: 100,
                Orders_PriceListERPCode: '',
                Orders_PriceListID: 380,
                Orders_PriceListType: 0,
                Orders_ProjectAddress: '',
                Orders_ProjectCity: '',
                Orders_ProjectCountry: '',
                Orders_ProjectCounty: '',
                Orders_ProjectName: '',
                Orders_ProjectNote: '',
                Orders_ProjectState: '5',
                Orders_ProjectType: 1,
                Orders_ProjectType_Code: 'C',
                Orders_ProjectType_ID: 1,
                Orders_ProjectType_Name: '',
                Orders_RecoverStatus: 0,
                Orders_RequestBillsStatus: 0,
                Orders_SN: '',
                Orders_SPCOrdersID: 680,
                Orders_SPCSN: '',
                Orders_ShortStock_Note: '',
                Orders_ShortStock_Status: 0,
                Orders_Site: 'CN',
                Orders_Source: '',
                Orders_SourceType: 2,
                Orders_Status: 1,
                Orders_SyncStatus: 0,
                Orders_SyncTime: '',
                Orders_SysUserID: 0,
                Orders_TMALLSN: '',
                Orders_Total_AllPrice: 3465,
                Orders_Total_Coin: 0,
                Orders_Total_Freight: 0,
                Orders_Total_FreightDiscount: 0,
                Orders_Total_FreightDiscount_Note: '',
                Orders_Total_MKTPrice: 38500,
                Orders_Total_Price: 3465,
                Orders_Total_PriceDiscount: 0,
                Orders_Total_PriceDiscount_Note: '',
                Orders_Total_UseCoin: 0,
                Orders_VerifyCode: '',
                Orders_VirtualInvoiceCode: '',
                Orders_VirtualRegionID: 18,
                Orders_WaitSignStatus: 1,
                Orders_WaitSignTime: '',
                Orders_Warranty: ''
            },
            Customer: {
                Customer_Account: 0,
                Customer_Accpter: '',
                Customer_AccpterTel: '',
                Customer_AgingCode: '',
                Customer_Bank: '',
                Customer_BankAccount: '',
                Customer_BranchOfficeID: 0,
                Customer_Cate: 0,
                Customer_CertExpireDate: '',
                Customer_City: '',
                Customer_Code: '',
                Customer_CompanyRegCode: '',
                Customer_ContractMan: ' ',
                Customer_ContractName: '',
                Customer_ContractPhone: '',
                Customer_ContractTel: ' ',
                Customer_Country: '',
                Customer_County: '',
                Customer_DebtAgingCode: '',
                Customer_DebtAmount: 0,
                Customer_Email: '',
                Customer_ID: 247,
                Customer_InvoiceAddr: '',
                Customer_InvoiceSendAddr: '',
                Customer_IsAudit: 1,
                Customer_IsBeLimited: 0,
                Customer_IsESign: 1,
                Customer_IsLimitPay: 0,
                Customer_IsProtocal: 0,
                Customer_LastYearCoopAmount: 0,
                Customer_Legalperson: '',
                Customer_LimitPayDebtMaxDays: 0,
                Customer_LimitPayMaxPlanDays: 0,
                Customer_MallCreditAmount: 0,
                Customer_MallCreditDays: 0,
                Customer_MallCreditEnable: 0,
                Customer_MallCreditExpired: '',
                Customer_MallCreditMaxDays: 0,
                Customer_MallCreditMaxPercent: 0,
                Customer_MaxAmount: 0,
                Customer_MaxDays: 0,
                Customer_MaxOrdersAmount: 0,
                Customer_Mobile: '',
                Customer_Name: '',
                Customer_OrdersOfficeManID: 0,
                Customer_PageCode: '',
                Customer_PayWay: '',
                Customer_PaymentERPTime: '',
                Customer_PaymentExpiredDate: '',
                Customer_PowerBIScore: 0,
                Customer_PriceListCode: '',
                Customer_RegAddr: ' ',
                Customer_Sponsor: '',
                Customer_SponsorCode: '',
                Customer_State: '',
                Customer_Status: 1,
                Customer_TaxAddr: '',
                Customer_TaxCode: '',
                Customer_Trash: 0,
                Customer_Type: 0,
                Customer_UpdateTime: ''
            },
            Member: {
                Member_NickName: ''
            },
            Invoicedetails: {
                Invoice_Accpter: '',
                Invoice_AccpterTel: '',
                Invoice_Content: '',
                Invoice_FirmName: '',
                Invoice_ID: 344,
                Invoice_OrdersID: 327,
                Invoice_SendAddr: '',
                Invoice_Title: '',
                Invoice_Type: 2,
                Invoice_VAT_Bank: '',
                Invoice_VAT_BankAcount: '',
                Invoice_VAT_Code: '',
                Invoice_VAT_Content: '',
                Invoice_VAT_FirmName: '',
                Invoice_VAT_RegAddr: '',
                Invoice_VAT_RegTel: ''
            },
            ordersStatus: '',
            ordersPayList: [],
            orderContract: [],
            orderPayMents: [],
            PerformanceDistribute: [],
            distributeshowstate: 0,
            orderAllocation: [],
            temporaryDelivery: [],
            shipmentApproval: [],
            shippingRecord: [],
            discountGrouping: [],
            Commoditylist: [],
            order_log: [],
            Orders_SPCOrdersDetails: {}, //关联合同详情
            allStatus: {
                auditStatus: '', //审核状态
                ordersBPMAuditStatus: '', //BPM审核状态
                ordersContractReceive: '', //合同纸回收状态
                ordersESignStatus: '' //电子签章状态
            },
            officemanInfo: {}, //业务员信息
            ordersProjectTypeStatus: '', //项目类型
            ProjectType_name: '', //行业类型
            cabinetSupplier: '', //配电柜厂家
            changeReason: '', //地址变更原因
            payMentDetails: {}, //付款方式
            customerSubInfo: '', //二级客户信息
            customerInfo: '', //二级客户信息
            memberInfo: { MemberProfileInfo: '' }, //会员信息
            batchButtonList: [], //关联订单批量操作按钮
            SPCOrdersRelateList: [], //关联订单列表
            BatchOrderId: [], //批量操作订单ID
            distributeList: [], //业绩分配比例

            buttonList: [], //订单详情按钮
            buttonResult: {}, //订单详情按钮
            payMentsHistoryList: [], //合同付款记录
            PayDistributeList: [], //合同付款分配
            DeliveryApplyList: [], //临时发货申请
            applyDiscountData: [], //折扣分组
            GoodsList: [], //商品清单
            auditLise: [], //审核说明
            ordersLogsList: [], //合同日志
            isSwitch: false, // bpm审核弹窗
            resendSwitch: false, // 重发合同弹窗
            isReturnGoods: 0, //是否返货
            printSwitch: false, // 打印弹窗
            printHtml: '', // 打印内容
            GoodsListPirce: 0, //商品金额
            sealTrue: false, // 打印盖章
            numsituation: 0, // 打印印章情况
            orderOperate: {}, // 订单操作数据
            BatchUploadShow: false, // 批量上传弹窗
            BatchPaymentShow: false, // 批量付款弹窗
            BatchDeliverShow: false, // 批量发货弹窗
            BatchTicketShow: false, // 批量开票弹窗
            BatchInvoiceShow: false, // 批量盖章弹窗
            contractPayShow: false,
            isDialogVisible: false,
            deliveryOrders_SN: '',
            deliveryApply_ID: 0,
            submitOrderShow: false, //  提交合同弹唱
            submitOrderData: {}, //提交合同数据
            PaymentID: 0, //付款单ID
            paymentShow: false //付款单弹窗
        };
    },
    computed: {
        ordersSMDSPipelineInfo() {
            const src = this.changeReason && this.changeReason.Orders_SMDSPipelineInfo;
            if (!src) return null;
            try {
                if (typeof src === 'string') {
                    const parsed = JSON.parse(src);
                    return parsed && Object.keys(parsed).length ? parsed : null;
                }
                return src && Object.keys(src).length ? src : null;
            } catch (e) {
                return null;
            }
        }
    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id, 'idid');
        if (id) {
            this.id = id;
            this.GetSPCOrdersByID(this.id);
        }
    },
    methods: {
        cellStyle() {
            return { padding: '0' }; // 去除单元格内边距
        },
        /**
         * 获取SPC订单详情 - 优化版本
         * 采用分批加载策略，buttonList 最优先加载，提升用户体验
         * @param {string|number} id 订单ID
         */
        async GetSPCOrdersByID(id) {
            const orderID = id; // Example order ID
            // const result = await this.$newsApi.contract.GetSPCOrdersByID({ ID: orderID });
            const result = await this.$newsApi.order.getSPCOrderDetailInfosByID({ id: orderID });
             //alert(result.data.Resultinfo);
            this.result = result.data.data;
            if (this.result.Extend.Orders_IsReturnGoods) {
                this.isReturnGoods = this.result.Extend.Orders_IsReturnGoods || 0;
            }
            let Address = {
                CountyCode: this.result.Orders_Address_County,
                stateCode: this.result.Orders_Address_State,
                CityCode: this.result.Orders_Address_City,
                CountryCode: this.result.Orders_Address_Country
            };
            let Project = {
                CountyCode: this.result.Orders_ProjectCounty,
                stateCode: this.result.Orders_ProjectState,
                CityCode: this.result.Orders_ProjectCity,
                CountryCode: this.result.Orders_ProjectCountry
            };
            let SPCOrderButton = {
                Orders_BPMAuditStatus: this.result.Orders_BPMAuditStatus,
                Orders_Status: this.result.Orders_Status,
                OrdersID: this.result.Orders_ID,
                Orders_ESignStatus: this.result.Orders_ESignStatus
            };
            this.PaymentAuditStatus = result.data.PaymentAuditStatus;
            this.ordersStatus = result.data.OrdersStatus;
            this.allStatus.auditStatus = result.data.OrdersAuditStatus;
            this.allStatus.ordersBPMAuditStatus = result.data.OrdersBPMAuditStatus;
            this.allStatus.ordersContractReceive = result.data.OrdersContractReceive;
            this.allStatus.ordersESignStatus = result.data.OrdersESignStatus;
            // 分批加载数据，优化加载速度
            let loadingInstance = this.$loading({ target: '.hw-content' }); // 显示 loading
            
            try {
                // 第一批：buttonList 最优先加载（合同管理页面的操作按钮）
                const buttonResult = await this.$newsApi.order.SPCOrder_Detail_Button({
                    Orders_ID: orderID,
                    Orders_Status: this.result.Orders_Status,
                    Orders_AuditStatus: this.result.Orders_Status,
                    Orders_BPMAuditStatus: this.result.Orders_BPMAuditStatus,
                    Orders_FreightType: this.result.Orders_FreightType,
                    Orders_PrePay_Percent: this.result.Orders_PrePay_Percent,
                    Orders_PaperContractSN: this.result.Orders_PaperContractSN,
                    Orders_SourceCate: this.result.Orders_SourceCate,
                    Orders_ESignStatus: this.result.Orders_ESignStatus,
                    orders_sn: this.result.Orders_SN
                });
                //alert(buttonResult.data.Resultinfo);
                // 处理 buttonList 数据
                if (buttonResult.data && buttonResult.data.data) {
                    this.buttonResult = buttonResult.data.data;
                    var arr = [];
                    for (var key in this.buttonResult) {
                        if (this.buttonResult[key] == '可用' || this.buttonResult[key] == '不可用') {
                            var obj = {};
                            obj.name = key;
                            obj.value = this.buttonResult[key];
                            arr.push(obj);
                        }
                    }
                    this.buttonList = arr;
                }

                // 第二批：核心状态数据和合同管理批量按钮
                const batch1 = await Promise.all([
                    // this.$newsApi.contract.OrdersStatus({ status: this.result.Orders_Status }),
                    // this.$newsApi.contract.GetAuditStatus({ status: this.result.Orders_AuditStatus }),
                    // this.$newsApi.contract.OrdersBPMAuditStatus({ status: this.result.Orders_BPMAuditStatus }),
                    // this.$newsApi.contract.OrdersContractReceive({ status: this.result.Orders_RecoverStatus }),
                    // this.$newsApi.contract.OrdersESignStatus({ status: this.result.Orders_ESignStatus }),
                    this.$newsApi.contract.SPCOrder_Detail_BatchButton(SPCOrderButton)
                ]);
                
                // 处理第二批数据 ordersStatus, auditStatus, ordersBPMAuditStatus, ordersContractReceive, ordersESignStatus, 
                const [batchButtonList] = batch1;
                // this.ordersStatus = ordersStatus && ordersStatus.data ? ordersStatus.data.data : null;
                // this.allStatus.auditStatus = auditStatus && auditStatus.data ? auditStatus.data.data : null;
                // this.allStatus.ordersBPMAuditStatus = ordersBPMAuditStatus && ordersBPMAuditStatus.data ? ordersBPMAuditStatus.data.data : null;
                // this.allStatus.ordersContractReceive = ordersContractReceive && ordersContractReceive.data ? ordersContractReceive.data.data : null;
                // this.allStatus.ordersESignStatus = ordersESignStatus && ordersESignStatus.data ? ordersESignStatus.data.data : null;
                this.batchButtonList = batchButtonList && batchButtonList.data ? batchButtonList.data.data : [];
                

                // 第三批：基础信息和地址数据（加载完成后关闭遮罩）
                const batch2 = await Promise.all([
                    this.$newsApi.contract.GetBranchOfficeMemberByID({ MemberID: this.result.Orders_OfficeManID }),
                    this.$newsApi.contract.DisplayProjectTypeRecursion({ ID: this.result.Orders_ProjectType_ID }),
                    this.$newsApi.contract.GetOrdersProjectTypeStatus({ status: this.result.Orders_ProjectType }),
                    this.$newsApi.contract.DisplayAddress(Address),
                    this.$newsApi.contract.DisplayAddress(Project)
                ]);
                
                // 处理第三批数据
                const [officemanInfo, projectType_name, ordersProjectTypeStatus, addressInfo, projectInfo] = batch2;
                this.officemanInfo = officemanInfo && officemanInfo.data ? officemanInfo.data.data : {};
                this.ProjectType_name = projectType_name && projectType_name.data ? projectType_name.data.data : '';
                this.ordersProjectTypeStatus = ordersProjectTypeStatus && ordersProjectTypeStatus.data ? ordersProjectTypeStatus.data.data : null;
                this.result.addressDetails = addressInfo && addressInfo.data ? addressInfo.data.resultinfo : null;
                this.result.projectDetails = projectInfo && projectInfo.data ? projectInfo.data.resultinfo : null;

                // 第三批加载完成，关闭遮罩

                // 第四批：合同扩展和付款信息
                const batch3 = await Promise.all([
                    this.$newsApi.contract.GetSPCOrdersExtendByID({ ID: orderID }),
                    this.$newsApi.contract.GetSPCOrdersPayDistribute({ OrdersID: orderID, Orders_PayType: this.result.Orders_PayType, Orders_PayType_Name: this.result.Orders_PayType_Name })
                ]);
                
                // 处理第四批数据
                const [SPCOrdersExtendByID, SPCOrdersPayDistribute] = batch3;
                this.changeReason = SPCOrdersExtendByID && SPCOrdersExtendByID.data ? SPCOrdersExtendByID.data.data : null;
                this.payMentDetails = SPCOrdersPayDistribute && SPCOrdersPayDistribute.data ? SPCOrdersPayDistribute.data.data : {};

                // 第五批：客户和会员信息
                const batch4 = await Promise.all([
                    this.result.Orders_CustomerSubID > 0 ? this.$newsApi.contract.GetCustomerSubByID({ ID: this.result.Orders_CustomerSubID }) : Promise.resolve(null),
                    this.$newsApi.contract.GetCustomerByID({ CustomerID: this.result.Orders_CustomerID }),
                    this.$newsApi.contract.GetMemberByID({ MemberID: this.result.Orders_BuyerID })
                ]);
                
                // 处理第五批数据
                const [customerSubInfo, customerInfo, memberInfo] = batch4;
                this.customerSubInfo = customerSubInfo ? customerSubInfo.data.data : {};
                this.customerInfo = customerInfo && customerInfo.data ? customerInfo.data.data : null;
                this.memberInfo = memberInfo && memberInfo.data ? memberInfo.data.data : null;

                // 第六批：订单相关详细数据
                const batch5 = await Promise.all([
                    this.$newsApi.contract.GetSPCOrdersRelateOrdersList({ Orders_ID: this.result.Orders_ID }),
                    this.$newsApi.contract.GetSPCOrdersPerformanceDistributeBySN({ Orders_SN: this.result.Orders_SN }),
                    this.$newsApi.contract.GetSPCOrdersPayMentsByOrdersID({ Orders_ID: orderID }),
                    this.$newsApi.contract.GetSPCOrdersDistributetReceiptByOrdersID({ OrdersID: this.result.Orders_ID, PaymentID: 0 }),
                    this.$newsApi.contract.GetSPCOrdersDeliveryApplyByOrdersID({ OrdersID: this.result.Orders_ID, PaymentID: 0 }),
                    this.$newsApi.contract.GetSPCOrdersDiscountCate({ orders_id: orderID }),
                    this.$newsApi.contract.GetSPCOrdersGoodsByOrdersID({ Orders_ID: orderID }),
                    this.$newsApi.contract.GetOrdersAuditNotesByOrdersID({ Orders_ID: orderID }),
                    this.$newsApi.contract.GetSPCOrdersLogsByOrdersID({ OrdersID: orderID })
                ]);
                this.$closeLoading(loadingInstance);
                // 处理第六批数据
                const [SPCOrdersRelateList, distributeList, payMentsHistoryList, PayDistributeList, DeliveryApplyList, applyDiscountData, GoodsList, auditLise, ordersLogsList] = batch5;
                this.SPCOrdersRelateList = SPCOrdersRelateList && SPCOrdersRelateList.data ? SPCOrdersRelateList.data.data : [];
                this.distributeList = distributeList && distributeList.data ? distributeList.data.data : [];
                this.distributeshowstate = distributeList.data.ShowState ? distributeList.data.ShowState : 0;
                this.payMentsHistoryList = payMentsHistoryList && payMentsHistoryList.data ? payMentsHistoryList.data.data : [];
                this.PayDistributeList = PayDistributeList && PayDistributeList.data ? PayDistributeList.data.data : [];
                this.DeliveryApplyList = DeliveryApplyList && DeliveryApplyList.data ? DeliveryApplyList.data.data : [];
                this.applyDiscountData = applyDiscountData && applyDiscountData.data ? applyDiscountData.data.data : {};
                this.GoodsList = GoodsList && GoodsList.data ? GoodsList.data.data : [];
                this.GoodsListPirce = GoodsList && GoodsList.data ? GoodsList.data.Total_Price : 0;
                this.auditLise = auditLise && auditLise.data ? auditLise.data.data : [];
                this.ordersLogsList = ordersLogsList && ordersLogsList.data ? ordersLogsList.data.data : [];

            } catch (error) {
                console.error('数据加载出错:', error);
                this.$closeLoading(loadingInstance);
                this.$message.error('数据加载失败，请刷新重试');
                return; // 出错时直接返回，不执行后续操作
            }

            this.CheckSPCOrdersNoCustomerSign();
            this.$nextTick(() => {
                if (this.SPCOrdersRelateList && this.SPCOrdersRelateList.length > 0) {
                    this.$refs.ordersRelateTble.toggleAllSelection();
                }
            });

            // 加载配电柜供应商信息（如果存在）
            if (this.changeReason && this.changeReason.Orders_CabinetSupplierID) {
                try {
                    let cabinetSupplierByCabinetSupplier = await this.$newsApi.contract.GetSPCOrdersCabinetSupplierByCabinetSupplierID({ ID: this.changeReason.Orders_CabinetSupplierID });
                    this.cabinetSupplier = cabinetSupplierByCabinetSupplier.data.data;
                } catch (error) {
                    console.warn('配电柜供应商信息加载失败:', error);
                    this.cabinetSupplier = null;
                }
            }
        },

        async loadAdditionalData() {
            const { Orders_OfficeManID, Orders_ID, Orders_ERPSN, Orders_PayType, Orders_PayType_Name, Orders_Address_Country, Orders_Address_State, Orders_Address_City, Orders_Address_County } = this.result;
            const [member, ordersPayList, addressInfo, performance] = await Promise.all([
                this.$newsApi.order.getMemberByID({ MemberID: Orders_OfficeManID }),
                this.$newsApi.order.getOrdersPayDistribute({ OrdersID: Orders_ID, Orders_PayType, Orders_PayType_Name }),
                this.$newsApi.common.getDisplayAddress({ countryCode: Orders_Address_Country, stateCode: Orders_Address_State, CityCode: Orders_Address_City, CountyCode: Orders_Address_County }),
                this.$newsApi.order.getOrdersPerformanceDistributeByERPSN({ OrdersID: Orders_ID, Orders_ERPSN })
            ]);
            this.Member = member.data.data;
            this.result.addressinfo = addressInfo.data.resultinfo;
            this.ordersPayList =
                ordersPayList.data.data.Detail.map((item) => ({
                    ...item,
                    PayTypeName: ordersPayList.data.data.PayTypeName
                })) || [];
            this.PerformanceDistribute = this.formatPerformanceData(performance.data.data);
        },
        formatPerformanceData(performanceData) {
            return performanceData.flatMap((item) => {
                if (item.OfficeMember && item.OfficeMember.length > 1) {
                    return item.OfficeMember.map((el, ix) => ({
                        ...item,
                        flag: ix === 0,
                        rowspan: item.OfficeMember.length,
                        ...el
                    }));
                }
                return [{ ...item, rowspan: 1, ...item.OfficeMember[0] }];
            });
        },

        formatCommodityList(commodityData) {
            return Array.isArray(commodityData) ? commodityData : [commodityData];
        },
        dataAssembly(newCommoditylist) {
            newCommoditylist.forEach((el, ix) => {
                el.Goods.unshift({ Goods_Product_MainBoxNumber: el.DiscountCateName, spanMethod: true, start: true });
                el.Goods.push({
                    Goods_Product_MainBoxNumber: '',
                    last: true,
                    spanMethod: true,
                    Porduct_Pirce: el.Porduct_Pirce,
                    Orders_Price: el.Orders_Price,
                    MinDiscount: el.MinDiscount
                });
                if (ix === newCommoditylist.length - 1) {
                    el.Goods.push({ Goods_Product_MainBoxNumber: '', spanMethod: true, last: true, maxlast: true });
                }
            });
            return newCommoditylist;
        },
        /*
        商品清单合并列
        */
        spanMethod({ rowIndex, columnIndex, row, column }) {
            // 合并第一行的所有单元格
            if (row.spanMethod) {
                return [1, 10]; // 1表示合并的行数，3表示合并的列数
            }
            return [1, 1]; // 默认每个单元格都占一行一列
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 判断是否为需要合并的列
            const skipColumns = [4, 5, 6, 7, 8, 9];
            // 仅当当前列索引不在需要跳过的列中时才进行合并
            if (!skipColumns.includes(columnIndex)) {
                if (row.flag) {
                    return {
                        rowspan: row.rowspan,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        /*
        下载附件
        */
        downFile(par) {
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        },
        /*
        关闭详情
        */
        handleClose(done) {
            this.$emit('handleClose');
            done();
        },
        handleSelectionChange(val) {
            this.BatchOrderId = val;
        },
        // 跳转合同详情
        goSPCdetail() {
            this.$router.push({ path: '/quotationManagement/quotationDetails', query: { id: this.result.Orders_SPCApplyID } });
        },
        goOrderdetail(OrdersID) {
            this.$router.push({ path: '/orderManagement/orderDetails', query: { id: OrdersID } });
        },
        // 跳转订单详情
        batchButtonClk(item) {
            let json = this.BatchOrderId.map((item) => {
                return item.Orders_ID;
            }).join();

            let obj = { OrdersID: this.id, OrdersSN: this.result.Orders_SN, OrdersAuditStatus: this.result.Orders_AuditStatus, batchId: json, isReturnGoods: this.isReturnGoods };
            this.orderOperate = obj;
            switch (item) {
                case '上传附件':
                    // this.$router.push({ path: '/orderManagement/BatchUpload', query: obj });
                    this.BatchUploadShow = true;
                    break;
                case '批量支付':
                    // this.$router.push({ path: '/orderManagement/BatchPayment', query: obj });
                    this.BatchPaymentShow = true;
                    break;
                case '批量发货':
                    // this.$router.push({ path: '/orderManagement/BatchDeliver', query: obj });
                    this.BatchDeliverShow = true;
                    break;
                case '批量开票':
                    // this.$router.push({ path: '/orderManagement/BatchTicket', query: obj });
                    this.BatchTicketShow = true;
                    break;
                case '批量免盖章':
                    // this.$router.push({ path: '/orderManagement/BatchInvoice', query: { ...obj, status: 1 } });
                    this.orderOperate.status = 1;
                    this.BatchInvoiceShow = true;
                    break;
                case '批量取消免盖章':
                    // this.$router.push({ path: '/orderManagement/BatchInvoice', query: { ...obj, status: 0 } });
                    this.orderOperate.status = 0;
                    this.BatchInvoiceShow = true;
                    break;
            }
        },
        // 订单按钮操作统一处理
        buttonDispose(e) {
            switch (e) {
                case '取消':
                    if (this.buttonResult['取消提示']) {
                        this.$confirm(this.buttonResult['取消提示'], '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                            .then(() => {
                                this.userCancle();
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });
                    } else {
                        this.userCancle();
                    }
                    break;
                case '提交':
                    if (this.buttonResult['提交提示']) {
                         this.$alert(this.buttonResult['提交提示'], '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            return false;
                        });
                        
                    } else {
                        this.goSubmitOrder();
                    }
                    break;
                case '修改':
                    this.changeOrder();
                    break;
                case '支付':
                    this.userPay();
                    break;
                case '修改纸质合同号':
                    this.modifyContractNo();
                    break;
                case '撤回电子签章':
                    this.contractsRevoke();
                    break;
                case '重发电子签章':
                    this.resendContract();
                    break;
            }
        },
        // 提交
        async goSubmitOrder(e) {
            let orderResult = await this.CheckOrdersConfirm(e);
            if (orderResult.Resultcode == 0 && orderResult.total == 999) {
                this.$alert(orderResult.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.goSubmitOrder(1);
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                return false;
            }
            if (orderResult.Resultcode == 1) {
                 await this.$alert(orderResult.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    return false;
                });
            }else{
                this.submitOrderData = { relation: e || 0, id: this.id, Total_Price: this.GoodsListPirce.toFixed(2), Orders_IsAllFreight: this.result.Orders_IsAllFreight  };
                this.submitOrderShow = true;
            }
        
            // this.$router.push({ path: '/orderManagement/submitPackOrder', query: { relation: e || 0, id: this.id, Total_Price: this.GoodsListPirce.toFixed(2) } });
        },
        // 订单详情检查提交
        async CheckOrdersConfirm(e) {
            let json = JSON.stringify({ relation: e || 0 });
            const result = await this.$newsApi.contract.CheckSPCOrdersConfirm({
                OrdersID: this.id,
                Json: json
            });
            return result.data;
        },
        // 取消
        userCancle() {
            this.$prompt('请输入取消原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /.+/,
                inputErrorMessage: '取消原因不能为空'
            }).then(({ value }) => {
                let data = {
                    Orders_ID: this.id,
                    orders_cancel_note: value
                };
                this.$newsApi.order.SPCOrders_Cancel({ json: JSON.stringify(data) }).then((res) => {
                    this.GetSPCOrdersByID(this.id);
                });
            });
        },
        resendContract() {
            this.resendSwitch = true;
        },
        contractsRevoke() {
            this.$prompt('请输入撤销原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /.+/,
                inputErrorMessage: '撤销原因不能为空'
            }).then(({ value }) => {
                let data = {
                    orders_cancel_note: value
                };
                this.$newsApi.contract.SPCOrdersContractsRevoke({ orders_id: this.result.Orders_ID, json: JSON.stringify(data) }).then((res) => {
                    if (res.Resultcode == 0) {
                        this.$message.success('撤销成功');
                    }
                    this.GetSPCOrdersByID(this.id);
                });
            });
        },
        handleRefresh(ordersId) {
            this.GetSPCOrdersByID(ordersId); // 调用刷新方法
        },
        async userPay() {
            let result = await this.$newsApi.order.CheckSPCOrdersPay({
                OrdersID: this.id
            });
            if (result.data.Resultcode == 0) {
                // this.$router.push({ path: '/orderManagement/orderPay', query: { orderId: this.id } });
                this.contractPayShow = true;
            } else if (result.data.Resultinfo) {
                this.$alert(result.data.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    callback: (action) => {}
                });
            }
        },
        // 修改合同
        async changeOrder() {
            this.$router.push({ path: '/customOrder', query: { id: this.id, changeIsReturnGoods: this.isReturnGoods } });
        },
        //获取订单详情按钮
        async GetOrderDetailButton() {
            var result = await this.$newsApi.order.SPCOrder_Detail_Button({
                Orders_ID: this.id,
                Orders_Status: this.result.Orders_Status,
                Orders_AuditStatus: this.result.Orders_Status,
                Orders_BPMAuditStatus: this.result.Orders_BPMAuditStatus,
                Orders_FreightType: this.result.Orders_FreightType,
                Orders_PrePay_Percent: this.result.Orders_PrePay_Percent,
                Orders_PaperContractSN: this.result.Orders_PaperContractSN,
                Orders_SourceCate: this.result.Orders_SourceCate,
                Orders_ESignStatus: this.result.Orders_ESignStatus,
                orders_sn: this.result.Orders_SN
            });
            var arr = [];
            result.data = result.data.data;
            if (result.data) {
                for (var key in result.data) {
                    if (result.data[key] == '可用' || result.data[key] == '不可用') {
                        var obj = {};
                        obj.name = key;
                        obj.value = result.data[key];
                        arr.push(obj);
                    }
                }
            }
            this.buttonResult = result.data;
            this.buttonList = arr;
        },
        // 订单详情-检查合同是否已客户签署
        async CheckSPCOrdersNoCustomerSign() {
            let result = await this.$newsApi.order.CheckSPCOrdersNoCustomerSign({
                OrdersID: this.id
            });
            if (result.data.data) {
                this.NoCustomerSign = result.data.data[0];
                this.NoCustomerSign.Checkbox = this.NoCustomerSign.Checkbox == 'true' ? true : false;
                this.result.Orders_IsNoCustomerSign = this.NoCustomerSign.Checkbox;
            }
        },
        async handleCheckboxChange(val) {
            this.result.Orders_IsNoCustomerSign = val;
            const status = val ? 1 : 0;
            let result = await this.$newsApi.order.SPCOrders_NoSign_Do({
                OrdersID: this.id,
                Status: status
            });
        },
        // 查看付款单
        payMentsHistoryView(e) {
            this.paymentShow = true;
            this.PaymentID = Number(e.Orders_Payment_ID);
            this.PaymentSN = e.Orders_Payment_DocNo;
        },
        // 查看凭证
        payDistributeView(e) {
            window.open(e);
        },
        // 查看BPM审核
        searchBpm(e) {
            this.isSwitch = true;
        },
        setSwitchClose() {
            this.isSwitch = false;
        },
        // 打印合同
        SPCOrdersShoppingList_HTML(e) {
            this.$newsApi.order.SPCOrdersShoppingList_HTML({ OrdersID: this.id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.printHtml = res.data.data;
                    this.$newsApi.order.SPCOrders_Goods_List_HTML({ OrdersID: this.id }).then((res) => {
                        if (res.data.Resultcode == 0) {
                            console.log(this.result,'1');
                            this.sealTrue = this.result.Orders_BPMAuditStatus == 2 ? true : false; // 是否打印印章
                            this.printHtml = this.printHtml + '<div class="PageNext">&nbsp;</div>' + res.data.data;
                            let IsPaperContractSN = false;
                            console.log(this.result.Orders_PaperContractSN,'Orders_PaperContractSN');
                            if (this.result.Orders_PaperContractSN.length > 0) {
                                IsPaperContractSN = true;
                            }
                            console.log(this.result.Orders_SourceCate,'Orders_SourceCate');
                            if (this.result.Orders_SourceCate == 1) {
                                IsPaperContractSN = false;
                            }
                            let numsituation = 0;
                            if (IsPaperContractSN) {
                                if (this.result.Orders_BPMAuditStatus == 2) {
                                    numsituation = 1;
                                } else {
                                    numsituation = 2;
                                }
                            } else {
                                if (this.result.Orders_BPMAuditStatus == 2) {
                                    numsituation = 3;
                                }
                            }
                            this.numsituation = numsituation;
                            this.printSwitch = true;
                        }
                    });
                }
            });
        },
        // 查看商品清单
        SPCOrdersProductExport(e) {
            this.$newsApi.order
                .SPCOrdersProductExport({ orders_id: this.id })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        window.open(this.$fileUrl + res.data.data, '_blank');
                        this.$message.success('导出成功，文件已开始下载'); // 添加成功提示
                    } else {
                        this.$message.error(`导出失败: ${res.data.Resultinfo}`); // 添加失败提示
                    }
                })
                .catch((error) => {
                    this.$message.error('导出请求失败' + error); // 网络错误提示
                });
        },
        printSwitchClose() {
            this.printSwitch = false;
        },
        resendSwitchClose() {
            this.resendSwitch = false;
        },
        // 是否打印印章
        printSeal(e) {
            console.log(e ? '打印印章' : '不打印印章');
        },
        /**
         * 获取商品图片地址，兼容网络图片和本地图片
         */
        getProductImgUrl(row) {
            const img = row.Goods_Product_Img;
            if (!img) {
                // 没有图片，返回默认本地图片
                return '/images/detail_no_pic.gif';
            } else {
                return img;
            }
            // // 如果是 /images/detail_no_pic.gif 或其他本地图片
            // if (img === '/images/detail_no_pic.gif' || img.startsWith('/images/')) {
            //     return img;
            // }
            // // 其他情况（如相对路径），可根据实际情况拼接
            // return img;
        },
        paymentSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 付款方式列合并
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: this.payMentDetails.Detail.length,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        // 批量上传
        BatchUploadRes(e) {
            this.BatchUploadShow = false;
            if (e) {
                // 刷新订单详情
                this.GetSPCOrdersByID(this.id);
            }
        },
        // 批量付款
        BatchPaymentRes(e) {
            this.BatchPaymentShow = false;
            if (e) {
                // 刷新订单详情
                this.GetSPCOrdersByID(this.id);
            }
        },
        // 批量发货
        BatchDeliverRes(e) {
            this.BatchDeliverShow = false;
            if (e) {
                // 刷新订单详情
                this.GetSPCOrdersByID(this.id);
            }
        },
        // 批量开票
        BatchTicketRes(e) {
            this.BatchTicketShow = false;
            if (e) {
                // 刷新订单详情
                this.GetSPCOrdersByID(this.id);
            }
        },
        // 批量免盖章
        BatchInvoiceRes(e) {
            this.BatchInvoiceShow = false;
            if (e) {
                // 刷新订单详情
                this.GetSPCOrdersByID(this.id);
            }
        },
        modifyContractNo() {
            if (this.result.Orders_PaperContractSN) {
                this.PaperContractSN = this.result.Orders_PaperContractSN.split('.')[1];
                this.modifyContractNoShow = true;
            }
        },
        async submitModifyContractNo() {
            let checkRes = await this.$newsApi.contract.CheckSPCOrdersPaperContractSN({ orders_id: this.id });
            if (checkRes.data.Resultcode != 0) {
                this.$message.error(`合同号校验失败: ${checkRes.data.Resultinfo}`); // 添加失败提示
                return;
            }
            let valid = await this.$refs.modifyContractNoForm.validate();
            if (valid) {
                let updateRes = await this.$newsApi.contract.SPCOrdersPaperContractEdit({
                    orders_id: this.id,
                    Orders_PaperContractSN: this.PaperContractSN
                });
                if (updateRes.data.Resultcode == 0) {
                    this.$message.success('合同号修改成功');
                    this.modifyContractNoShow = false;
                    this.GetSPCOrdersByID(this.id); // 刷新订单详情
                } else {
                    this.$message.error(`合同号修改失败: ${updateRes.data.Resultinfo}`);
                }
            }
        },
        deliveryApplyView(row) {
            this.deliveryApply_ID = Number(row.Apply_ID);
            this.deliveryOrders_SN = this.result.Orders_SN;
            this.isDialogVisible = true;
        },
        submitOrderComplete() {
            this.submitOrderShow = false;
            this.GetSPCOrdersByID(this.id);
            this.$router.push({ path: '/orderManagement/contractmanagementAll', query: { t: Date.now() } });
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}

.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}

.links {
    color: #409eff;
    cursor: pointer;
}

.red {
    color: #f56c6c;
    margin-right: 10px;
}

.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }

    /deep/.cell {
        padding: 0;
    }
}

.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}

.cart-list {
    background-color: #ffffff;
    font-size: 14px;

    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;

        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }

    .cart-top-title-big {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}

.total {
    font-size: 14px;

    margin-top: 10px;

    span {
        color: red;
        padding-right: 20px;
    }
}

.flex {
    display: flex;
    align-items: center;
}

/deep/.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

/deep/.el-table--border .el-table__cell {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

/deep/.el-table {
    border: 1px solid #ccc;
}

.red-title {
    text-align: right !important;

    color: #cc0000;
    font-weight: 700;
}

/* 批量发货弹窗样式 */
/deep/.batch-deliver-dialog {
    .el-dialog {
        margin-top: 2vh !important;
    }
    .el-dialog__body {
        max-height: 90vh;
        overflow-y: auto;
        padding: 20px;
    }
    .el-dialog__header {
        padding: 15px 20px 10px;
    }
}

.office-box {
    .no-border-table {
        border: none !important;
        /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none !important;
        /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none;
        border: none !important;
        /* 去掉表格行的边框 */
    }

    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
        border: none !important;
    }
}
</style>